const MAX_META_LENGTH = 160;

const clean = (value) => String(value || '').trim().slice(0, MAX_META_LENGTH);

const normalizeSessionUrl = (value) => {
    try {
        const url = new URL(String(value || ''), 'https://invalid.local');
        if (url.hostname === 'invalid.local' && !String(value || '').startsWith('/')) return '';
        url.hash = '';
        return url.hostname === 'invalid.local' ? `${url.pathname}${url.search}`.slice(0, 500) : url.toString().slice(0, 500);
    } catch (e) {
        return clean(value);
    }
};

const buildMessageMeta = ({ intent = '', intentLabel = '', source = '', triggerSource = '', errorCode = '', url = '' } = {}) => ({
    intent: clean(intent),
    intent_label: clean(intentLabel),
    source: clean(source),
    trigger_source: clean(triggerSource),
    error_code: clean(errorCode),
    url: normalizeSessionUrl(url)
});

const isTechnicalFallback = (value) => clean(value) === 'Entschuldigung, es gab ein Problem bei der Verarbeitung. Bitte versuche es erneut.';

module.exports = { normalizeSessionUrl, buildMessageMeta, isTechnicalFallback };
